var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIConsignLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 49 33",
    style: {
      enableBackground: "new 0 0 49 33"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{enable-background:new    ;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6,26.4c-1.2,0-2.3-0.2-3.3-0.5c-1-0.3-1.9-0.8-2.7-1.4l1.7-2.6c1.3,0.9,2.7,1.4,4.3,1.4c0.8,0,1.5-0.1,2-0.4 c0.5-0.3,0.8-0.7,0.8-1.3c0-0.8-0.6-1.4-1.9-1.8l-2-0.5c-1.4-0.4-2.4-0.9-3.1-1.7c-0.7-0.8-1-1.7-1-3c0-1.5,0.5-2.7,1.6-3.6 c1.1-0.9,2.6-1.3,4.5-1.3c1,0,2,0.1,2.9,0.4c0.9,0.3,1.8,0.7,2.6,1.3l-1.6,2.6c-1.1-0.8-2.4-1.2-3.8-1.2c-0.7,0-1.3,0.1-1.8,0.4 S5,13.9,5,14.5c0,0.4,0.2,0.8,0.5,1s0.8,0.5,1.4,0.6l2,0.5c1.3,0.4,2.4,0.9,3.1,1.7c0.7,0.8,1.1,1.8,1.1,3c0,1.6-0.6,2.8-1.7,3.7 C10.2,25.9,8.6,26.4,6.6,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6,26V9.2h3.5v6.5c0.4-0.7,0.9-1.2,1.5-1.6c0.6-0.4,1.3-0.6,2.1-0.6c1.2,0,2.1,0.4,2.8,1.3c0.6,0.8,1,2,1,3.6V26H23 v-7.4c0-0.7-0.1-1.2-0.4-1.6c-0.3-0.4-0.7-0.6-1.4-0.6c-0.5,0-0.9,0.1-1.2,0.3c-0.3,0.2-0.6,0.5-0.9,0.8V26H15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3,12.5c-0.6,0-1.1-0.2-1.5-0.5c-0.4-0.3-0.6-0.8-0.6-1.4s0.2-1,0.6-1.4c0.4-0.3,0.9-0.5,1.5-0.5s1.1,0.2,1.5,0.5 s0.6,0.8,0.6,1.4s-0.2,1-0.6,1.4S31.8,12.5,31.3,12.5z M29.5,26V13.8H33V26H29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2,30.6V13.8h3.3v2.1c0.3-0.7,0.8-1.3,1.5-1.7c0.6-0.4,1.4-0.6,2.2-0.6c1.4,0,2.5,0.5,3.2,1.6s1.2,2.5,1.2,4.3v1 c0,1.8-0.4,3.3-1.2,4.3s-1.9,1.6-3.2,1.6c-1.6,0-2.7-0.7-3.4-2.2v6.5H36.2z M41.8,16.4c-0.9,0-1.6,0.4-2.1,1.1v4.6 c0.5,0.7,1.2,1.1,2.1,1.1c0.7,0,1.3-0.3,1.7-0.8c0.4-0.5,0.6-1.3,0.6-2.2v-0.8c0-1-0.2-1.7-0.6-2.2C43,16.7,42.5,16.4,41.8,16.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIConsignLogo);
export default __webpack_public_path__ + "static/media/iConsignLogo.598b10d8518d8e80d8671f2701e0e457.svg";
export { ForwardRef as ReactComponent };